export default "__VITE_ASSET__DTRSYNCo__"